.successCheck {
  --ixf-success-check-illustration-path-mask-color: var(--ixf-color-background);
  --ixf-success-check-illustration-size: 86px;

  display: flex;
  flex-direction: column;
  align-items: center;

  .illustrationContainer {
    position: relative;
    display: block;
    width: var(--ixf-success-check-illustration-size);
    height: var(--ixf-success-check-illustration-size);
    flex: 0 0 auto;
  }

  .checkmark {
    position: absolute;
  }

  .checkmark {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .pathMask {
      stroke: var(--ixf-success-check-illustration-path-mask-color);

      &.animationComplete {
        stroke: none;
      }
    }
  }

  .stop {
    &Primary {
      stop-color: var(--ixf-color-primary-md);
    }

    &Secondary {
      stop-color: var(--ixf-color-secondary-md);
    }

    &Tertiary {
      stop-color: var(--ixf-color-tertiary-md);
    }

    &Quaternary {
      stop-color: var(--ixf-color-quaternary-md);
    }

    &Danger {
      stop-color: var(--ixf-color-danger-md);
    }
  }
}
